import { supabase } from '@/integrations/supabase/client';

export type NotificationKind = 'test_published' | 'test_scheduled_live' | 'job_published' | 'general';

export const NOTIFICATION_KIND_LABEL: Record<string, string> = {
  test_published: 'New test',
  test_scheduled_live: 'Live now',
  job_published: 'New job',
};

export interface AppNotification {
  id: string;
  title: string;
  body: string;
  link: string | null;
  kind: NotificationKind;
  created_at: string;
}

/** Insert a broadcast notification. Admin-only via RLS. Safe to await/ignore failures. */
export async function createNotification(opts: {
  title: string;
  body?: string;
  link?: string | null;
  kind?: NotificationKind;
}): Promise<boolean> {
  const { data: { user } } = await supabase.auth.getUser();
  const { error } = await supabase.from('notifications').insert({
    title: opts.title,
    body: opts.body ?? '',
    link: opts.link ?? null,
    kind: opts.kind ?? 'general',
    created_by: user?.id ?? null,
  } as any);
  if (error) {
    console.warn('createNotification failed:', error.message);
    return false;
  }
  return true;
}